import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-我的",
  "use": "icon-我的-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-我的\"><path d=\"M799.544 608c-64.488 56.64-148.344 94.416-245.088 94.416S373.856 664.664 302.912 608C141.608 689.84 32 796.856 32 992h1032c0-195.144-109.656-295.872-264.456-384z\" p-id=\"2702\" /><path d=\"M536 632c160.008 0 288-136.968 288-300S696.008 32 536 32 248 168.968 248 332C248 501.56 382.4 632 536 632z\" p-id=\"2703\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol